import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "./Redux/Store";
import Unauthorized from "./Pages/Unauthorized";

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { hasAccess, loading, checked } = useSelector(
    (state: RootState) => state.AdminAccess,
  );

  // Wait for the access check to actually run before deciding: on a hard
  // refresh Redux resets to its initial state before fetchAdminAccess has
  // had a chance to dispatch, and that initial state must not be treated as
  // a confirmed denial (it previously caused a false redirect to "/").
  if (loading || !checked) return null;
  if (!hasAccess) return <Unauthorized />;

  return <>{children}</>;
};

export default AdminRoute;
